import { Cross1Icon } from "@radix-ui/react-icons";
import { IconButton, TextField } from "@radix-ui/themes";
import { FC, useMemo } from "react";

export type InputProps = {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  defaultValue?: string;
  disabled?: boolean;
  type?: "text" | "password" | "email" | "number";
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  clearable?: boolean;
};

export const Input: FC<InputProps> = (props) => {
  const { onChange, value, clearable = false, ...rest } = props;

  const isClearable = useMemo(
    () => clearable && value !== "",
    [clearable, value],
  );
  return (
    <TextField.Root
      onChange={(e) => onChange?.(e.target.value)}
      value={value}
      {...rest}
    >
      {isClearable && (
        <TextField.Slot side="right">
          <IconButton size="1" variant="ghost" onClick={() => onChange?.("")}>
            <Cross1Icon height="14" width="14" />
          </IconButton>
        </TextField.Slot>
      )}
    </TextField.Root>
  );
};
